import { render, staticRenderFns } from "./AdditionalDrivers.vue?vue&type=template&id=0f8edb4d&"
import script from "./AdditionalDrivers.vue?vue&type=script&lang=js&"
export * from "./AdditionalDrivers.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalDrivers.vue?vue&type=style&index=0&id=0f8edb4d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports